var _defs, _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "23.824%",
    x2: "100%",
    y2: "50%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#6366F1",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.8,
    fill: "#312E81",
    filter: "url(#a)",
    cx: 28,
    cy: 28,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21 -13.072 56.536)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.648 20.678 2.76 9.253L0 13.94l12.648 6.737Z",
    fillOpacity: 0.265,
    fill: "#A5B4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    opacity: 0.8,
    d: "M12.648 20.678 0 13.94 15.408 0v2.676l-1.816 15.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M12.648 20.678 15.408 0l15.589 15.642z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.997 15.642 15.407 29.93l-2.76-9.253 18.35-5.036Z",
    fill: "url(#d)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.32,
    fill: "#38BDF8",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#e)",
    cx: 15.542,
    cy: 15,
    r: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon03);
export default __webpack_public_path__ + "static/media/features-icon-03.4d61f2442611774c513a7dddc66a47f7.svg";
export { ForwardRef as ReactComponent };